import styled from 'styled-components'
//////////////////////////////////////////////////////////////////
//////////////****AUTHOR : AGHILES AZZOUG -  *////////////////////
//////////////*****JUIN - AOUT 2021 */////////////////////////////
/////////////Développement et design /////////////////////////////
/////////Propriété privé de Layer Data - Rachid Tighremt//////////
////////Tous droits reservés ... interdit tout plagiat ///////////
////////    interdit tout usage sans autorisation     ////////////
///////---------------------------------------------//////////////
//////////////////////////////////////////////////////////////////
export const CommercialContainer = styled.section`

height: 60vh;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
background: #fff;
@media only screen and (max-width:1000px) {
  height: 60rem;

}
@media only screen and (max-width:768px) {
  height: 30rem;

}


`;
export const CommercialH1 = styled.h1`
font-size: 4rem;
color: #1fa8ff;
margin-bottom: 6.4rem;

@media only screen and (max-width: 480px){
  font-size: 3.2rem
}
`;

export const CommercialCard = styled.div`
${'' /* background-color: #1fa8ff;
display: flex;
flex-direction: column;
text-align: center;
border-radius: 10px;
max-height: 34rem;
padding: 2rem;
box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
transition: all .5s ease;
line-height: 1.4;

&:hover{
  transform: scale(1.1);
  cursor: pointer;

  @media only screen and (max-width:768px){
    transform: scale(1.02);
    height: 5rem;
    width: 5rem;
  } */}
}

/* @media only screen and (max-width:1900px){
    max-height: 50rem;
  } */
`;
export const CommercialIcon = styled.img`
height: 13rem;
width: 13rem;
margin-bottom: 1rem;
margin: 0 auto;
@media only screen and (max-width:768px){
  height: 12rem;
  width: 12rem;
  }
`;
export const CommercialH2 = styled.h2`
padding-top: 1rem;
margin-bottom: 1rem;
font-size: 1.3rem;
color: #fff;
font-weight: bold;


`;

export const CommercialP = styled.p`
text-align: center;
font-size: 1.2rem;
color: #fff;
`;

export const UrlCardLink = styled.a`
text-decoration: none;
&:hover {
  text-decoration: underline;
}
&:visited {
  text-decoration: none;
}
`;